@if (!!currentContact) {
<onsip-contact class="app-view__section" [contact]="currentContact"> </onsip-contact>
}
